<template lang="pug">
	.network-show--cues-list.flex-col.space
		ListView.full-width.no-padding(
			ref="list",
			initialView="cards",
			:getTotal="(r) => r.TotalNumberOfRecords",
			:getItems="(r) => r.Results",
			:getData="$Data.getNetworkShowCues",
			:filterRow="true",
			:remoteSorting="true",
			:hideViewsSelection="true",
			:autoFit="true",
			:heightDelta="50",
			:showColumnHeaders="false",
			:searchVisible="true",
			:topPagerVisible="false"
		)
			template(v-slot:left-actions="{ data }")
				.flex-row.space-medium.align-center
					.font-big.upper.grey {{$tCaption('Network cues')}}
					DxButton(icon="plus", :hint="$tCaption('New network cue')", @click="newCue")
			template(v-slot:card="{ data }")
				.flex-row.space.cue-item.clickable.hoverable.align-center(@click="editCue(data)")
					fas(icon="bookmark")
					.font-big {{data.Name}}
		Popup(v-if="editingPopup.visible", :popupVisible="editingPopup.visible", :width="420", :height="250", :title="editingPopup.cue.Oid ? $tCaption('Network show cue') : $tCaption('New network show cue')")
			.flex-col.space-medium
				EditableLabelField(:caption="$tCaption('Name')", :value.sync="editingPopup.cue.Name", :editingMode="true", stylingMode="filled")
				Loader(v-if="editingPopup.loading", text="", :fullscreen="true")
			template(slot="actions-left")
				DxButton(v-if="editingPopup.cue.Oid", :text="$tCaption('Delete', '@actions')", @click="deleteCue(editingPopup.cue.Oid)", type="danger", :disabled="!!editingPopup.loading")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="editingPopup.visible = false")
				DxButton(:text="$tCaption('Save', '@actions')", @click="processEditingCue", type="success", :disabled="!!editingPopup.loading")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import EditableLabelField from 'app-core/EditableLabelField.vue';
	import Popup from 'app-core/Popup.vue';
	import ListView from 'app-core/ListView.vue';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'networkShow.CuesList',
		name: 'network-show--cues-list',
		props: [],
		components: {
			EditableLabelField, DxButton, Popup, ListView, Loader
		},
		data() {
			return {
				editingCue: null,
				editingPopup: {
					visible: false,
					cue: null,
					loading: false
				}
			};
		},
		mounted() {
			if (__DEBUG__)
				window.networkShowCues = this;
		},
		methods: {
			editCue(cue) {
				this.editingPopup.visible = false;
				this.editingPopup.cue = cue;
				this.$nextTick(() => this.editingPopup.visible = true);
			},
			newCue() {
				this.editCue({
					Name: null,
					Oid: null
				});
			},
			processEditingCue() {
				this.editingPopup.loading++;
				this.$Data.createUpdateNetworkShowCue(this.editingPopup.cue).then(() => {
					this.editingPopup.visible = false;
					this.$refs.list.reload();
				}).finally(() => this.editingPopup.loading--);
			},
			deleteCue(id) {
				this.$confirm().then(() => {
					this.editingPopup.loading++;
					this.$Data.deleteNetworkShowCue(id).then(() => {
						this.editingPopup.visible = false;
						this.$refs.list.reload();
					}).finally(() => this.editingPopup.loading--);
				});
			}
		}
	};
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.network-show--cues-list {
		.card {
			flex: auto !important;
			width: 100%;
			margin: 0px;
			padding: 10px 0px;
			border-bottom: 1px solid #eaeaea;
		}
	}
</style>
